export const RESET_API_FETCH_ERRORS = 'RESET_API_FETCH_ERRORS';
export const RESET_API_FETCH_LOADING = 'RESET_API_FETCH_LOADING';
